import { render, staticRenderFns } from "./contentSidebar.vue?vue&type=template&id=ddcc1632&scoped=true&"
import script from "./contentSidebar.vue?vue&type=script&lang=js&"
export * from "./contentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./contentSidebar.vue?vue&type=style&index=0&id=ddcc1632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcc1632",
  null
  
)

export default component.exports